var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-top"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.avatar}})]),_c('div',{staticClass:"user"},[_vm._v(" 管理员："),_c('span',[_vm._v(_vm._s(_vm.info.name))])]),_c('div',{staticClass:"btn",on:{"click":_vm.logout}},[_vm._v("退出登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }